/**
 * Product Tabs – Vanilla JS
 * Handles desktop tab switching and keyboard navigation.
 * Mobile uses native <details> accordion (no JS needed).
 */
(function () {
  'use strict';

  document.querySelectorAll('.product-tabs').forEach(function (container) {
    var nav = container.querySelector('.product-tabs__nav');
    var tabs = nav ? Array.from(nav.querySelectorAll('[role="tab"]')) : [];
    var panels = Array.from(container.querySelectorAll('.product-tabs__panels [role="tabpanel"]'));

    if (tabs.length === 0 || panels.length === 0) return;

    /**
     * Activate a tab by index
     */
    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    /**
     * Click handler
     */
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(index);
      });
    });

    /**
     * Keyboard navigation (arrow keys, Home, End)
     */
    nav.addEventListener('keydown', function (event) {
      var currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex = currentIndex;

      switch (event.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          newIndex = (currentIndex + 1) % tabs.length;
          event.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          event.preventDefault();
          break;
        case 'Home':
          newIndex = 0;
          event.preventDefault();
          break;
        case 'End':
          newIndex = tabs.length - 1;
          event.preventDefault();
          break;
        default:
          return;
      }

      tabs[newIndex].focus();
      activateTab(newIndex);
    });
  });
})();
